module.exports = __webpack_public_path__ + "img/w3-cover.ce8f5160.jpg";